/** @format */
import { useTranslation } from 'next-i18next';
import React, { FunctionComponent } from 'react';

import { Link, LinkSize } from '@toucan/client/shared/components/link';

import { Notification } from '../notification';
import { OutOfStockNotificationProps } from './types';

export * from './types';
// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const DEFAULT_TEST_ID = 'summary-item__offline-product';

export const OutOfStockNotification: FunctionComponent<
    OutOfStockNotificationProps
> = ({ handleReplace, 'data-testid': dataTestId = DEFAULT_TEST_ID }) => {
    const { t } = useTranslation();

    return (
        <Notification
            data-testid={dataTestId}
            title={t('Our stock moves fast!')}
            body={t('Someone else just snapped this one up.')}
        >
            <Link
                onClick={handleReplace}
                data-testid={`${dataTestId}__out-of-stock-replace`}
                size={LinkSize.SMALL}
            >
                {t('Find another like this')}
            </Link>
        </Notification>
    );
};
